import { customBaseQuery } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export interface PlanCreate {
  name: string;
  sales_order_limit: number | null; // null = Unlimited
  price: number;
  description?: string;
}

export interface PlanResponse {
  id: number;
  name: string;
  sales_order_limit: number | null;
  sales_order_limit_label: string;
  price: number;
  description?: string;
}

export interface CurrentPlanResponse {
  plan: PlanResponse;
  subscription: null | {
    id: number;
    status: string;
    start_date?: string;
    end_date?: string;
  };
  is_default: boolean;
}

export interface PlanUsageResponse {
  used: number;
  limit: number;
  remaining: number;
  is_unlimited: boolean;
  upgrade_required: boolean;
  upgrade_message: string | null;
  flipkart_orders: number;
  meesho_orders: number;
  amazon_orders: number;
}

export const planApi = createApi({
  reducerPath: "planApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Plan"],
  endpoints: (builder) => ({
    createPlan: builder.mutation<PlanResponse, PlanCreate>({
      query: (body) => ({
        url: `/subscription/plans`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Plan"],
    }),
    getPlans: builder.query<PlanResponse[], void>({
      query: () => ({
        url: `/subscription/plans`,
        method: "GET",
      }),
      providesTags: ["Plan"],
    }),
    getCurrentPlan: builder.query<CurrentPlanResponse, void>({
      query: () => ({
        url: `/subscription/current-plan`,
        method: "GET",
      }),
      providesTags: ["Plan"],
    }),
    getPlanUsage: builder.query<PlanUsageResponse, void>({
      query: () => ({
        url: `/subscription/usage`,
        method: "GET",
      }),
      providesTags: ["Plan"],
    }),
    createOrder: builder.mutation<
      { order_id: string; amount: number; currency: string; plan_name: string },
      { plan_id: number }
    >({
      query: (body) => ({
        url: `/order/create-order`,
        method: "POST",
        body,
      }),
    }),

    // ✅ VERIFY PAYMENT
    verifyPayment: builder.mutation<
      { message: string; plan_id: number },
      { order_id: string; payment_id: string; signature: string }
    >({
      query: (body) => ({
        url: `/order/verify-payment`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Plan"],
    }),

  }),
});

export const {
  useCreatePlanMutation,
  useGetCurrentPlanQuery,
  useGetPlanUsageQuery,
  useCreateOrderMutation,
  useVerifyPaymentMutation,
  useGetPlansQuery
} = planApi;
